<template>
  <div class="ti d-flex">
    <div class="d-flex-left">
      <erp-tree @node-click="nodeClick"></erp-tree>
    </div>
    <div class="d-flex-right">
      <Row class="loading" :style="loading == true ? '' : 'display:none'">
        <Col class="demo-spin-col" span="8">
          <Spin fix>
            <Icon
              type="ios-loading"
              size="18"
              class="demo-spin-icon-load"
            ></Icon>
            <div>加载中</div>
          </Spin>
        </Col>
      </Row>
      <div style="display: flex">
        <div class="cdj_el-input el-date-pickers">
          <el-date-picker
            size="mini"
            v-model="payStartDate"
            type="date"
            placeholder="开始时间"
          ></el-date-picker>
          <span class="cdj_text_data">至</span>
          <el-date-picker
            size="mini"
            v-model="payEndDate"
            type="date"
            placeholder="结束时间"
          ></el-date-picker>
        </div>
        <!-- <el-date-picker size="mini" v-model="date" type="date" placeholder="选择日期"></el-date-picker> -->
        <div style="margin-left: 3px">
          <el-button size="mini" type="primary text2" @click="searchs"
            >搜索</el-button
          >
          <el-button
            size="mini"
            type="success text2"
            style="margin-left: 1px; margin-bottom: 10px"
            @click="excelPost"
            >导出</el-button
          >
        </div>
      </div>
      <div>房产：{{ homeName }}</div>
      <v-divider></v-divider>
      <v-simple-table :height="__TABLE_HEIGHT__">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">客户</th>
              <th class="text-left">房产</th>
              <th class="text-left">费用类型</th>
              <th class="text-left">财务科目</th>
              <th class="text-left">结算方式</th>
              <th class="text-left">发生额</th>
              <th class="text-left">折扣</th>
              <th class="text-left">发生时间</th>
              <th class="text-left">票据号码</th>
              <th class="text-left">操作员</th>
              <th class="text-left">账期</th>
            </tr>
          </thead>
          <tbody>
            <tr class="text1" v-for="item in data" :key="item.id">
              <td>{{ item.h_name }}</td>
              <td>{{ item.h_name_date }}</td>
              <td>{{ item.cname }}</td>
              <td>{{ item.chargeItem_name }}</td>
              <td>{{ item.pay_pname }}</td>
              <td>{{ item.charge_adjust_after }}</td>
              <td>{{ item.discount_adjust_after}}</td>
              <td>{{ item.date }}</td>
              <td>{{ item.bill_number }}</td>
              <td>{{ item.user_name }}</td>
              <td>{{ item.startDate }}至{{ item.endDate }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-divider></v-divider>
      <div class="pages" v-if="data">
        <Page
          :total="count"
          :page-size="pageSize"
          @on-change="change"
          show-total
        />
      </div>
      <div class="zhanwu" v-else>没有数据</div>
    </div>
    <excel-task
      ref="ExcelTask"
      :excelTask="excelTask"
      :excelTaskId="excelTaskId"
      @close="closeExcelTask"
    />
  </div>
</template>

<script>
import ErpTree from "../Common/erp-tree";
import imgurl from "../../../assets/js/imgurl.js";
import ExcelTask from "@/components/common/excelTask";
export default {
  name: "OrderDailyList",
  components: { ErpTree, ExcelTask },
  data() {
    return {
      modal1: false,
      loading: false,
      loadingModal: true,
      optionsHouse: [],
      dades: {
        id: "",
        pindex_id: "",
        house_id: "",
        name: "",
        identification_card: "",
        phone: "",
        gender: "",
        birthday: "",
        ownership_type: "",
        customer_class: "",
        customer_type: "",
        specialIdentity: "",
      },
      date: "",
      payStartDate: "",
      payEndDate: "",
      options: [],
      pid: "",
      data: "",
      count: 0,
      pageSize: 12,
      anxiu: "保存",
      homeName: "",
      types: 2,
      excelTaskId: null,
      excelTask: false,
    };
  },
  //界面没出来前加载
  created() {},
  // 加载数据
  mounted() {
    let da = this.$route.query.date;
    if (da) {
      this.date = da; //获得今天
      this.payStartDate = da;
      this.payEndDate = da;
    } else {
      this.date = new Date(); //获得今天
      this.payStartDate = new Date(); //获得今天
      this.payEndDate = new Date(); //获得今天
    }
    this.pid = this.$route.query.pid;
    this.homeName = this.$route.query.homeName;

    this.change(1);
    //项目列表
    this.$myhttp
      .get("admin/common/pindex", {
        "Content-Type": "application/json",
      })
      .then((backdata) => {
        this.options = backdata.data.data;
      });
  },
  //事件
  methods: {
    //获得当前多少页,分页
    change(page) {
      if (this.payStartDate == null || this.payStartDate == "") {
        this.$Message.error("请选择日期范围");
        return false;
      }
      if (this.payEndDate == null || this.payEndDate == "") {
        this.$Message.error("请选择日期范围");
        return false;
      }
      if (this.pid == "") {
        if (this.types == 1) {
          this.$Message.error("请选择房产");
        }
        return false;
      }
      let d = this.payStartDate; //开始时间
      let payStartDate = new Date(d).getTime() / 1000;
      payStartDate = Number(payStartDate).toFixed(0);
      let s = this.payEndDate; //结束时间
      let payEndDate = new Date(s).getTime() / 1000;
      payEndDate = Number(payEndDate).toFixed(0);

      this.loading = true;
      this.$myhttp
        .get(
          "admin/OrderDailyList/index?page=" +
            page +
            "&pid=" +
            this.pid +
            "&homeName=" +
            this.homeName +
            "&payStartDate=" +
            payStartDate +
            "&payEndDate=" +
            payEndDate,
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          // 异步执行成功后
          if (backdata.data.code == 200) {
            let data = backdata.data.data;
            this.data = data.data;
            this.count = data.count;
            this.pageSize = data.pageSize;
          }
          this.loading = false;
        });
    },
    excelPost() {
      if (this.payStartDate == null || this.payStartDate == "") {
        this.$Message.error("请选择日期范围");
        return false;
      }
      if (this.payEndDate == null || this.payEndDate == "") {
        this.$Message.error("请选择日期范围");
        return false;
      }
      if (this.pid == "" || this.pid == null) {
        this.$Message.error("请选择房产项目");
        return false;
      }
      let d = this.payStartDate; //开始时间
      let payStartDate = new Date(d).getTime() / 1000;
      payStartDate = Number(payStartDate).toFixed(0);
      let s = this.payEndDate; //结束时间
      let payEndDate = new Date(s).getTime() / 1000;
      payEndDate = Number(payEndDate).toFixed(0);
      let data = {};
      data.pid = this.pid;
      data.homeName = this.homeName;
      data.payStartDate = payStartDate;
      data.payEndDate = payEndDate;
      data.targetController = "OrderDailyList";
      data.targetFunction = "excel";
      data.taskName = "收银日报表";
      this.loading = true;
      this.$myhttp
        .post("admin/excelTask/addTask", data, {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          // 异步执行成功后
          this.loading = false;
          // 异步执行成功后
          this.$store.commit("excelTaskAdd");
          this.$Message.success("导出任务已创建!");
          var data = backdata.data.data;
          this.excelTaskId = data.excelTaskId;
          this.openExcelTask();
        });
    },
    //搜索
    searchs() {
      this.types = 1;
      this.change(1);
    },
    //修改
    xiugai(item) {
      (this.dades = {
        id: item.id,
        pindex_id: item.pindex_id,
        house_id: item.house_id,
        name: item.name,
        identification_card: item.identification_card,
        phone: item.phone,
        gender: item.gender,
        birthday: item.birthday,
        ownership_type: item.ownership_type,
        customer_class: item.customer_class,
        customer_type: item.customer_type,
        specialIdentity: item.specialIdentity,
      }),
        (this.modal1 = true);
    },
    //弹窗不要关闭
    loadingModals() {
      let _this = this;
      _this.loadingModal = false;
      setTimeout(() => {
        _this.loadingModal = true;
      }, 10);
    },
    nodeClick(data) {
      let tree_str = data.tree
        .map((ret) => {
          return ret.name;
        })
        .join("->");
      this.pid = data.tree[0].id;
      this.homeName = tree_str;
      this.change(1);
    },
    openExcelTask() {
      this.$store.commit("excelTaskClear");
      this.excelTask = true;
      this.$refs.ExcelTask.change(1);
    },
    closeExcelTask() {
      this.excelTask = false;
    },
  },
  watch: {
    //监听项目id改变
    "dades.pindex_id"(e) {
      if (this.dades.pindex_id != undefined && this.dades.pindex_id != "") {
        this.loading = true;
        this.$myhttp
          .get("admin/common/house?id=" + e, {
            "Content-Type": "application/json",
          })
          .then((backdata) => {
            this.optionsHouse = backdata.data.data;
            this.loading = false;
          });
      }
    },
  },
  computed: {
    __TABLE_HEIGHT__() {
      return ERP.getStore().__TABLE_HEIGHT__;
    },
  },
};
</script>
<style scoped>
.ti {
  margin: 1%;
  width: 98%;
}
.text1 {
  text-align: center;
}
.pages {
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search {
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2 {
  color: rgb(250, 248, 248);
}
.kuan {
  width: 10%;
}
.zhanwu {
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
}
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.demo-spin-col {
  height: 100px;
  position: relative;
}
.loading {
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 90%;
  width: 85%;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/OrderDaily/List.vue